import { render, staticRenderFns } from "./GroupScheduleExamUpdate.vue?vue&type=template&id=3b959541&"
import script from "./GroupScheduleExamUpdate.vue?vue&type=script&lang=js&"
export * from "./GroupScheduleExamUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports